import { Injectable } from '@angular/core';
import { map, filter, tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';
import { ConvertIdService } from 'src/app/core/services/convert-id.service';
import { IOrganization } from '../../../shared/models/user/organization';
import { IOrgReview } from '../../../shared/models/review';
import { DialogService } from '../../../core/services/dialogs/dialogs.service';
import { IPaginationFilter } from '../../../shared/models/filter';
import { AuthService } from '../../../core/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  constructor(
    private base: BaseService,
    private convertIdService: ConvertIdService,
    private auth: AuthService
  ) {}

  public getOrgInfo(id: string | number) {
    const isAuth = this.auth.isFullyAuthorized;
    const entry = isAuth ? `user` : `guest`;
    const _id = typeof id === 'number' ? id : this.getId(id);

    return this.base
      .get(`${entry}/view/${_id}`)
      .pipe(map((response: any) => response.user as IOrganization));
  }

  public getMembersOrg(id: string) {
    return this.base.get(`user/members/${this.getId(id)}`).pipe(
      map((response: any) => ({
        members: response.members,
        count: response.count
      }))
    );
  }

  public getReviewOrg({ id, offset }: IPaginationFilter) {
    const filter = `?offset=${offset}&limit=${5}`;

    return this.base
      .get(`review/user/${this.getId(id)}`)
      .pipe(map((response: any) => (response.reviews ?? []) as object[]));
  }

  public getClubs(id: string) {
    return this.base
      .get(`group/clubs/${this.getId(id)}`)
      .pipe(map((response: any) => (response.clubs ?? []) as object[]));
  }

  public getChapters(id: string) {
    return this.base
      .get(`chapters/${this.getId(id)}`)
      .pipe(map((response: any) => (response.chapters ?? []) as object[]));
  }

  public getJobs(id: string) {
    return this.base
      .get(`user/jobs/${this.getId(id)}`)
      .pipe(map((response: any) => (response.jobs ?? []) as object[]));
  }

  public addReview(review: IOrgReview) {
    const formated = {
      text: review.text,
      obj_id: review.obj_id,
      privaci: review.privaci ? 1 : 0
    };

    return this.base
      .post('review/add', formated)
      .pipe(map((response: any) => response.review));
  }

  protected getId(id: string): string {
    return this.convertIdService.convertIdStringToNumber(id);
  }

  addResourceAllRelatedClubs(post) {
    return this.base
      .post('clubs/resource', post)
      .pipe(map((response: any) => response));
  }
}
